export class Users {
  constructor(http) {
    this.http = http;
  }

  fetchUser(id) {
    return this.http.get(`account/${id}`).then(response => response.data);
  }

  fetchAccountPassword(id) {
    return this.http.get(`account_password/${id}`).then(response => response.data);
  }

  updateUser(user) {
    return this.http.put(`account/${user.id}`, { ...user }).then(response => response.data);
  }
}
